// Two input questions, kept apart on purpose:
// - no hover: the primary input can't hover (phones, tablets). Reveal hover-only
//   UI, select by tap, and treat Enter as a line break on the touch keyboard.
// - coarse pointer: the primary pointer is a finger. Size targets and fields for it.
export const NO_HOVER_QUERY = '(hover: none)';
export const COARSE_POINTER_QUERY = '(pointer: coarse)';

export const NO_HOVER_MEDIA = `@media ${NO_HOVER_QUERY}`;
export const COARSE_POINTER_MEDIA = `@media ${COARSE_POINTER_QUERY}`;

// iOS Safari zooms the page when a field under 16px gets focus.
export const COARSE_POINTER_FIELD_FONT = {
	[COARSE_POINTER_MEDIA]: {
		fontSize: '16px',
	},
};

export const isNoHoverDevice = (): boolean =>
	typeof window !== 'undefined' && window.matchMedia(NO_HOVER_QUERY).matches;

export const isCoarsePointer = (): boolean =>
	typeof window !== 'undefined' &&
	window.matchMedia(COARSE_POINTER_QUERY).matches;
